import type { CrmMessages } from "./englishCrmMessages";

export const frenchCrmMessages = {
  resources: {
    companies: {
      name: "Entreprise |||| Entreprises",
      forcedCaseName: "Entreprise",
      fields: {
        name: "Nom de l'entreprise",
        website: "Site web",
        linkedin_url: "LinkedIn",
        phone_number: "Numéro de téléphone",
        created_at: "Date de création",
        nb_contacts: "Nombre de contacts",
        revenue: "Chiffre d'affaires",
        sector: "Secteur",
        size: "Taille",
        tax_identifier: "Identifiant fiscal",
        address: "Adresse",
        city: "Ville",
        zipcode: "Code postal",
        state_abbr: "État",
        country: "Pays",
        description: "Description",
        context_links: "URLs de contexte",
        sales_id: "Responsable de compte",
      },
      empty: {
        description: "Il semble que la liste de vos entreprises soit vide.",
        title: "Aucune entreprise trouvée",
      },
      import: {
        title: "Importer des entreprises",
      },
      field_categories: {
        contact: "Contact",
        additional_info: "Informations supplémentaires",
        address: "Adresse",
        context: "Contexte",
      },
      action: {
        create: "Créer une entreprise",
        edit: "Modifier l'entreprise",
        new: "Nouvelle entreprise",
        show: "Afficher l'entreprise",
      },
      added_on: "Ajoutée le %{date}",
      followed_by: "Suivie par %{name}",
      followed_by_you: "Suivie par vous",
      no_contacts: "Aucun contact",
      nb_contacts: "%{smart_count} contact |||| %{smart_count} contacts",
      nb_deals: "%{smart_count} affaire |||| %{smart_count} affaires",
      sizes: {
        one_employee: "1 employé",
        two_to_nine_employees: "2-9 employés",
        ten_to_forty_nine_employees: "10-49 employés",
        fifty_to_two_hundred_forty_nine_employees: "50-249 employés",
        two_hundred_fifty_or_more_employees: "250 employés ou plus",
      },
      autocomplete: {
        create_error:
          "Une erreur s'est produite lors de la création de l'entreprise",
        create_item: "Créer %{item}",
        create_label: "Commencez à taper pour créer une nouvelle entreprise",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
      forcedCaseName: "Contact",
      field_categories: {
        background_info: "Informations complémentaires",
        identity: "Identité",
        misc: "Divers",
        personal_info: "Informations personnelles",
        position: "Poste",
      },
      fields: {
        first_name: "Prénom",
        last_name: "Nom",
        last_seen: "Dernière activité",
        title: "Titre",
        company_id: "Entreprise",
        email_jsonb: "Adresses e-mail",
        email: "E-mail",
        phone_jsonb: "Numéros de téléphone",
        phone_number: "Numéro de téléphone",
        linkedin_url: "URL LinkedIn",
        background: "Informations de contexte",
        has_newsletter: "Abonné à la newsletter",
        sales_id: "Responsable de compte",
      },
      action: {
        add: "Ajouter un contact",
        add_first: "Ajoutez votre premier contact",
        create: "Créer un contact",
        edit: "Modifier le contact",
        export_vcard: "Exporter en vCard",
        new: "Nouveau contact",
        show: "Afficher le contact",
      },
      autocomplete: {
        create_item: "Créer %{item}",
        create_label: "Saisissez du texte pour créer un contact",
      },
      background: {
        last_activity_on: "Dernière activité le %{date}",
        added_on: "Ajouté le %{date}",
        followed_by: "Suivi par %{name}",
        followed_by_you: "Suivi par vous",
        status_none: "Aucun",
      },
      position_at: "%{title} chez",
      position_at_company: "%{title} chez %{company}",
      empty: {
        description: "Il semble que votre liste de contacts soit vide.",
        title: "Aucun contact trouvé",
      },
      import: {
        title: "Importer des contacts",
      },
      inputs: {
        genders: {
          male: "Monsieur",
          female: "Madame",
          nonbinary: "Indéterminé",
        },
        personal_info_types: {
          work: "Pro",
          home: "Perso",
          other: "Autre",
        },
      },
      list: {
        error_loading: "Erreur lors du chargement des contacts",
      },
      show: {
        error_loading: "Erreur lors du chargement du contact",
      },
      bulk_tag: {
        action: "Étiqueter",
        back: "Retour aux étiquettes",
        create_description:
          "Créez une nouvelle étiquette et appliquez-la aux contacts sélectionnés.",
        description:
          "Choisissez une étiquette existante ou créez-en une pour les contacts sélectionnés.",
        empty:
          "Aucune étiquette pour le moment. Créez-en une pour étiqueter les contacts sélectionnés.",
        error: "Impossible d'ajouter l'étiquette aux contacts",
        removed:
          "Étiquette retirée de %{smart_count} contact |||| Étiquette retirée de %{smart_count} contacts",
        success:
          "Étiquette ajoutée à %{smart_count} contact |||| Étiquette ajoutée à %{smart_count} contacts",
        title: "Ajouter une étiquette aux contacts",
      },
      merge: {
        action: "Fusionner avec un autre contact",
        confirm: "Fusionner les contacts",
        current_contact: "Contact actuel (sera supprimé)",
        description: "Fusionnez ce contact avec un autre.",
        error: "Échec de la fusion des contacts",
        merging: "Fusion...",
        no_additional_data: "Aucune donnée supplémentaire à fusionner",
        select_target: "Veuillez sélectionner un contact avec lequel fusionner",
        success: "Contacts fusionnés avec succès",
        target_contact: "Contact cible (sera conservé)",
        title: "Fusionner les contacts",
        warning_description:
          "Toutes les données seront transférées au deuxième contact. Cette action ne peut pas être annulée.",
        warning_title: "Avertissement : opération destructrice",
        what_will_be_merged: "Ce qui sera fusionné :",
      },
      filters: {
        before_last_month: "Avant le mois dernier",
        before_this_month: "Avant ce mois-ci",
        before_this_week: "Avant cette semaine",
        managed_by_me: "Géré par moi",
        search: "Rechercher nom, entreprise...",
        this_week: "Cette semaine",
        today: "Aujourd'hui",
        tags: "Étiquettes",
        tasks: "Tâches",
      },
      hot: {
        empty_change_status:
          'Changez le statut d\'un contact en ajoutant une note à ce contact et en cliquant sur "afficher les options".',
        empty_hint: 'Les contacts avec un statut "chaud" apparaîtront ici.',
        title: "Contacts chauds",
      },
    },
    leads: {
      name: "Prospect |||| Prospects",
      forcedCaseName: "Prospect",
      fields: {
        name: "Nom",
        phone: "Téléphone",
        email: "E-mail",
        company_name: "Société",
        comment: "Commentaire",
        source: "Source",
        stage_id: "Étape",
        project_id: "Projet",
        sales_id: "Responsable",
        contact_id: "Contact",
        created_at: "Reçu",
      },
      action: {
        new: "Nouveau prospect",
        create: "Nouveau prospect",
        back: "Retour au prospect",
      },
      updated: "Prospect mis à jour",
    },
    deals: {
      name: "Affaire |||| Affaires",
      forcedCaseName: "Affaire",
      fields: {
        name: "Nom",
        description: "Description",
        company_id: "Entreprise",
        contact_ids: "Contacts",
        categories: "Catégories",
        amount: "Budget",
        expected_closing_date: "Date de clôture prévue",
        stage: "Étape",
        sales_id: "Responsable de compte",
        project_id: "Projet",
        pipeline_id: "Pipeline",
        stage_id: "Étape",
      },
      action: {
        back_to_deal: "Retour à l'affaire",
        create: "Créer une affaire",
        new: "Nouvelle affaire",
      },
      field_categories: {
        misc: "Divers",
      },
      filters: {
        only_mine: "Seulement les affaires que je gère",
      },
      archived: {
        action: "Archiver",
        error: "Erreur : affaire non archivée",
        list_title: "Affaires archivées",
        success: "Affaire archivée",
        title: "Affaire archivée",
        view: "Afficher les affaires archivées",
      },
      inputs: {
        linked_to: "Lié à",
      },
      unarchived: {
        action: "Renvoyer au tableau",
        error: "Erreur : affaire non désarchivée",
        success: "Affaire désarchivée",
      },
      updated: "Affaire mise à jour",
      empty: {
        before_create: "avant de créer une affaire.",
        description: "Il semble que votre liste d'affaires soit vide.",
        title: "Aucune affaire trouvée",
      },
      import: {
        title: "Importer des affaires",
      },
      invalid_date: "Date invalide",
    },
    notes: {
      name: "Note |||| Notes",
      forcedCaseName: "Note",
      fields: {
        status: "Statut",
        date: "Date",
        attachments: "Pièces jointes",
        contact_id: "Contact",
        deal_id: "Affaire",
      },
      action: {
        add: "Ajouter une note",
        add_first: "Ajoutez votre première note",
        delete: "Supprimer la note",
        edit: "Modifier la note",
        update: "Mettre à jour la note",
        add_this: "Ajouter cette note",
      },
      sheet: {
        create: "Créer une note",
        create_for: "Créer une note pour %{name}",
        edit: "Modifier la note",
        edit_for: "Modifier la note pour %{name}",
      },
      deleted: "Note supprimée",
      empty: "Aucune note pour l'instant",
      author_added: "%{name} a ajouté une note",
      you_added: "Vous avez ajouté une note",
      system_added: "1C",
      bitrix_added: "Bitrix24",
      me: "Moi",
      list: {
        error_loading: "Erreur lors du chargement des notes",
      },
      note_for_contact: "Note pour %{name}",
      stepper: {
        hint: "Accédez à une page de contact et ajoutez une note",
      },
      added: "Note ajoutée",
      inputs: {
        add_note: "Ajouter une note",
        options_hint: "(joindre des fichiers ou modifier les détails)",
        show_options: "Afficher les options",
      },
      actions: {
        attach_document: "Joindre un document",
      },
      validation: {
        note_or_attachment_required: "Une note ou une pièce jointe est requise",
      },
    },
    sales: {
      name: "Utilisateur |||| Utilisateurs",
      fields: {
        first_name: "Prénom",
        last_name: "Nom",
        email: "E-mail",
        secondary_email: "E-mail secondaire",
        secondary_emails: "E-mails secondaires",
        administrator: "Admin",
        disabled: "Désactivé",
        password: "Mot de passe",
      },
      create: {
        error:
          "Une erreur s'est produite lors de la création de l'utilisateur.",
        success: "Utilisateur créé.",
        title: "Créer un nouvel utilisateur",
      },
      edit: {
        error: "Une erreur s'est produite. Veuillez réessayer.",
        record_not_found: "Enregistrement introuvable",
        success: "Utilisateur mis à jour avec succès",
        title: "Modifier %{name}",
      },
      action: {
        new: "Nouvel utilisateur",
      },
    },
    tasks: {
      name: "Tâche |||| Tâches",
      forcedCaseName: "Tâche",
      fields: {
        text: "Description",
        due_date: "Date d'échéance",
        type: "Type",
        contact_id: "Contact",
        due_short: "échéance",
      },
      action: {
        add: "Ajouter une tâche",
        create: "Créer une tâche",
        edit: "Modifier la tâche",
      },
      actions: {
        postpone_next_week: "Reporter à la semaine prochaine",
        postpone_tomorrow: "Reporter à demain",
        title: "Actions de tâche",
      },
      added: "Tâche ajoutée",
      deleted: "Tâche supprimée avec succès",
      dialog: {
        create: "Créer une tâche",
        create_for: "Créer une tâche pour %{name}",
      },
      sheet: {
        edit: "Modifier la tâche",
        edit_for: "Modifier la tâche pour %{name}",
      },
      empty: "Aucune tâche pour l'instant",
      empty_list_hint: "Les tâches ajoutées à vos contacts apparaîtront ici.",
      filters: {
        later: "Plus tard",
        overdue: "En retard",
        this_week: "Cette semaine",
        today: "Aujourd'hui",
        tomorrow: "Demain",
        with_pending: "Avec des tâches en attente",
      },
      regarding_contact: "(Concernant : %{name})",
      updated: "Tâche mise à jour",
    },
    tags: {
      name: "Étiquette |||| Étiquettes",
      action: {
        add: "Ajouter une étiquette",
        create: "Créer une nouvelle étiquette",
      },
      dialog: {
        color: "Couleur",
        create_title: "Créer une nouvelle étiquette",
        edit_title: "Modifier l'étiquette",
        name_label: "Nom de l'étiquette",
        name_placeholder: "Saisir le nom de l'étiquette",
      },
      empty: "Aucune étiquette pour le moment.",
    },
  },
  crm: {
    action: {
      reset_password: "Réinitialiser le mot de passe",
    },
    auth: {
      first_name: "Prénom",
      last_name: "Nom",
      confirm_password: "Confirmer le mot de passe",
      confirmation_required:
        "Veuillez suivre le lien que nous venons de vous envoyer par email pour confirmer votre compte.",
      recovery_email_sent:
        "Si vous êtes un utilisateur enregistré, vous devriez recevoir prochainement un e-mail de récupération de mot de passe.",
      sign_in_failed: "Échec de la connexion.",
      sign_in_google_workspace: "Connectez-vous avec Google Workplace",
      signup: {
        create_account: "Créer un compte",
        create_first_user:
          "Créez le premier compte utilisateur pour terminer la configuration.",
        creating: "Création...",
        initial_user_created: "Utilisateur initial créé avec succès",
      },
      welcome_title: "Bienvenue sur Atomic CRM",
    },
    clients: {
      tabs_label: "Clients",
      people: "Personnes",
      companies: "Sociétés",
    },
    projects: {
      confirm_delete_stage: "Supprimer l'étape « %{name} » ?",
      confirm_delete_pipeline:
        "Supprimer le pipeline « %{name} » et ses étapes ?",
      confirm_delete_hint:
        "Une étape qui contient des fiches ne peut pas être supprimée : déplacez-les d'abord.",
      no_active_title: "Aucun projet actif",
      no_active_description:
        "Tous les projets sont archivés. Créez un projet ou restaurez-en un.",
      open_settings: "Paramètres → Projets",
      import_choose_project: "Import : choisissez un projet",
      outcome_label: "Issue",
      pipeline_name: "Nom du pipeline",
      errors: {
        stage_exists: "Ce pipeline a déjà une étape de ce nom",
        member_exists: "Cet employé est déjà dans le projet",
      },
      switcher: "Projet",
      all: "Tous les projets",
      pipelines_label: "Pipelines d'affaires",
      none_title: "Vous n'êtes encore dans aucun projet",
      none_description:
        "Le propriétaire ajoute les employés aux projets dans Paramètres → Employés.",
      title: "Projets",
      general: "Général",
      tabs_label: "Sections des paramètres",
      new: "Nouveau projet",
      create: "Créer",
      name: "Nom",
      color: "Couleur",
      archive: "Archiver",
      unarchive: "Restaurer",
      archived: "archivé",
      lead_pipeline: "Prospects",
      add_pipeline: "Pipeline d'affaires",
      new_pipeline_name: "Nouveau pipeline",
      delete_pipeline: "Supprimer le pipeline",
      stages: "Étapes",
      add_stage: "Ajouter une étape",
      new_stage: "Nouvelle étape",
      stage_name: "Nom de l'étape",
      drag: "Glisser pour réordonner",
      delete_stage: "Supprimer l'étape",
      lead_rules:
        "Un pipeline de prospects a une étape « gagnée » et au moins une étape « perdue ».",
      members: "Membres",
      add_member: "Ajouter un employé",
      no_members: "Personne ne travaille encore sur ce projet",
      remove_member: "Retirer",
      saved: "Enregistré",
      owner_sees_all: "Le propriétaire voit tout",
      can_delete: "Peut supprimer",
      can_export: "Peut exporter",
      staff_title: "Employés",
      new_employee: "Nouvel employé",
      edit_employee: "Modifier",
      outcome: {
        open: "en cours",
        won: "gagnée",
        lost: "perdue",
      },
      access: {
        label: "Accès",
        none: "Aucun accès",
        own: "Ses fiches",
        department: "Son service",
        all: "Tout le projet",
      },
      roles: {
        owner: "Propriétaire",
        head: "Responsable",
        manager: "Commercial",
      },
    },
    leads: {
      sources: {
        call: "Appel",
        site: "Site",
        avito: "Avito",
        drom: "Drom",
        email: "E-mail",
        other: "Autre",
      },
      convert: "En affaire",
      open_deal: "Ouvrir l'affaire",
      converted: "L'affaire est créée",
      convert_error: "Impossible de créer l'affaire",
      no_responsible: "Sans responsable",
      only_mine: "Seulement mes prospects",
      view_label: "Vue",
      view_board: "Tableau",
      view_list: "Liste",
      list: "Prospects",
      empty: "Aucun prospect",
      choose_project:
        "Le tableau s'affiche pour un projet : choisissez-le en haut. Ci-dessous, les prospects de tous les projets.",
      won_hint: "Les prospects arrivent ici par «En affaire»",
      column_count: "%{smart_count} prospect |||| %{smart_count} prospects",
    },
    connections: {
      title: "Connexions",
      is_set: "saisi ✓",
      not_set: "non saisi",
      save: "Enregistrer",
      remove: "Supprimer",
      saved: "Enregistré",
      removed: "Supprimé",
      replace_placeholder: "Saisissez une nouvelle valeur pour la remplacer",
      generate: "Créer une nouvelle",
      generate_confirm:
        "L'ancienne clé ne marchera plus. En créer une nouvelle ?",
      generate_yes: "Oui, créer",
      generated_once: "Copiez-la maintenant : cette clé ne sera plus affichée.",
      paste_own: "Ou collez la clé du compte PBX",
      copy: "Copier",
      copy_failed:
        "Copie impossible. Sélectionnez le texte et copiez-le à la main",
      public_url: "Adresse du CRM",
      public_url_hint:
        "Sert aux liens des notifications et aux adresses ci-dessous. Par exemple, https://crm.example.com",
      public_url_bad: "L'adresse doit commencer par https:// ou http://",
      mail: {
        title: "Boîte mail de l'entreprise",
        leads_from_unknown: "Les e-mails d'adresses inconnues créent un lead",
        leads_from_unknown_hint:
          "Un e-mail d'une adresse qui n'est pas un contact devient un lead. Désactivé, le CRM ignore ces e-mails.",
        hint: "Les e-mails des employés sans boîte personnelle partent de cette boîte. Le CRM y lit aussi les réponses.",
        people: "Boîtes personnelles des employés",
        people_empty: "Personne n'a encore de boîte personnelle",
        remove_person: "Supprimer la boîte de l'employé",
      },
      telegram: {
        title: "Telegram",
        hint: "Les employés reçoivent dans Telegram les nouveaux prospects, les appels manqués, les transferts et étapes des affaires, les tâches en retard.",
        steps:
          "1. Créez un bot avec @BotFather (/newbot) et collez son jeton ici. 2. Chaque employé saisit son chat_id dans le profil et clique sur « Tester ».",
        bot_token: "Jeton du bot",
        api_base: "Adresse du proxy Telegram",
        api_base_hint:
          "Seulement si l'hébergement n'accède pas à api.telegram.org. Vide en général.",
      },
      leads: {
        title: "Prospects du site et des plateformes",
        hint: "Le formulaire du site et d'autres services envoient les prospects à cette adresse (POST).",
        token: "Clé des prospects",
        url_label: "Adresse des prospects",
        header_hint:
          "La clé passe dans l'adresse (?token=) ou dans l'en-tête X-Hook-Token.",
      },
      telephony: {
        title: "Téléphonie",
        provider: "PBX",
        provider_none: "Aucun",
        provider_megafon: "MegaFon",
        lines: "Numéros de l'entreprise et projets",
        lines_hint:
          "Un appel vers un numéro listé va dans son projet. Les autres vont dans le projet du client ou le principal.",
        number: "Numéro",
        project: "Projet",
        add_line: "Ajouter un numéro",
        remove_line: "Retirer le numéro",
        save: "Enregistrer la téléphonie",
        saved: "Téléphonie enregistrée",
        megafon_hint:
          "Dans le compte PBX (« Intégration CRM »), saisissez l'adresse ci-dessous et la clé des requêtes du PBX. Prenez-y aussi l'adresse et la clé de l'API.",
        megafon_url_label: "Adresse du CRM pour le PBX",
        megafon_crm_token: "Clé des requêtes du PBX",
        megafon_api_url: "Adresse de l'API du PBX",
        megafon_api_key: "Clé de l'API du PBX",
        own_title: "PBX propre",
        own_hint:
          "Notre PBX envoie les événements d'appel à cette adresse avec l'en-tête X-Telephony-Token.",
        own_token: "Clé des événements d'appel",
        own_url_label: "Adresse des événements",
      },
      onec: {
        title: "1C",
        hint: "Les commandes et paiements de 1C s'affichent sur l'affaire. Le CRM lit 1C toutes les 30 minutes sans rien y modifier.",
        steps:
          "1. Publiez l'interface OData dans 1C et créez un utilisateur en lecture seule. 2. Saisissez l'adresse, l'identifiant et le mot de passe, activez la synchronisation. 3. Les commerciaux écrivent le numéro de l'affaire dans le commentaire de la commande, par exemple CRM-101.",
        enabled: "Synchronisation avec 1C",
        odata_url: "Adresse OData",
        odata_url_hint:
          "Par exemple, http://1c.example.fr/base/odata/standard.odata",
        bad_url: "L'adresse doit commencer par http:// ou https://",
        key: "Comment 1C marque le numéro d'affaire",
        prefix: "Avant le numéro",
        number: "numéro d'affaire",
        suffix: "Après le numéro",
        suffix_placeholder: "peut être vide",
        example: "Exemple :",
        key_hint:
          "Le commercial l'écrit dans le numéro ou le commentaire de la commande. Une deuxième commande de la même affaire : CRM-101-2. Un nombre sans ce préfixe n'est pas lié. Dans l'exemple, ␣ signifie une espace.",
        prefix_empty: "Indiquez ce qui précède le numéro, par exemple CRM-",
        key_long: "20 caractères au plus avant et après le numéro",
        prefix_bad:
          "Avant le numéro : des lettres et aucun chiffre, par exemple CRM-",
        suffix_bad: "Après le numéro : aucun chiffre",
        password_cleared:
          "L'adresse 1C a changé, le mot de passe 1C a donc été effacé. Saisissez de nouveau le mot de passe 1C",
        user: "Identifiant 1C",
        password: "Mot de passe 1C",
        save: "Enregistrer 1C",
        saved: "Réglages 1C enregistrés",
        check: "Vérifier la connexion",
        check_hint:
          "Vérifie l'adresse, l'identifiant et le mot de passe enregistrés.",
        check_ok: "1C répond. Première commande : %{number} du %{date}",
        check_ok_empty: "1C répond. Aucune commande pour l'instant",
      },
    },
    telegram: {
      chat_id: "chat_id Telegram",
      check: "Tester",
      sent: "Message envoyé, regardez Telegram",
      saved: "chat_id enregistré",
      hint: "Pour recevoir les notifications, trouvez le bot de l'entreprise dans Telegram et appuyez sur « Démarrer » (/start). @userinfobot vous donne votre chat_id : écrivez-lui et copiez le nombre Id.",
    },
    bitrix: {
      title: "Bitrix24",
      hint: "Clients, prospects, affaires, notes et tâches de Bitrix24. Le CRM lit Bitrix sans rien y modifier.",
      steps:
        "1. Dans Bitrix ouvrez Ressources développeur → Autre → Webhook entrant, cochez les droits crm, user et task et enregistrez. 2. Collez l'adresse du webhook ici. 3. Lancez « Transfert d'essai » et regardez le résultat. 4. Lancez « Transférer » ou activez la synchronisation.",
      webhook: "Adresse du webhook",
      webhook_hint:
        "Elle ressemble à https://adresse-du-portail/rest/1/cle/. Une fois enregistrée, l'adresse n'est plus affichée.",
      mode: "Synchronisation avec Bitrix24",
      mode_on:
        "Activée : toutes les 10 minutes le CRM récupère les changements de Bitrix. Les fiches de Bitrix sont en lecture seule ici et se modifient dans Bitrix. Vous pouvez y ajouter vos notes et tâches.",
      mode_off:
        "Désactivée : le CRM est tenu ici. Pour transférer une fois les données de Bitrix, lancez « Transférer ».",
      check: "Vérifier",
      check_ok: "Bitrix24 répond. Le webhook appartient à %{name}",
      check_ok_empty: "Bitrix24 répond",
      dry_run: "Transfert d'essai",
      run: "Transférer",
      run_hint:
        "Le transfert d'essai n'écrit rien et montre ce qui serait créé. Un nouveau transfert met les fiches à jour, sans doublons.",
      no_webhook: "Collez d'abord l'adresse du webhook et enregistrez-la",
      run_confirm_title: "Transférer les données de Bitrix24 ?",
      run_confirm:
        "Cela peut prendre quelques minutes. Les fiches apparaissent dans le CRM, le résultat s'affiche ci-dessous.",
      dry_started: "Le transfert d'essai a commencé",
      started: "Le transfert a commencé",
      running: {
        import: "Transfert en cours…",
        dry: "Transfert d'essai en cours…",
        sync: "Synchronisation en cours…",
        starting: "Démarrage…",
      },
      last_pulled: "Dernier transfert : %{time}",
      report_dry: "Transfert d'essai %{time} : rien n'a été écrit dans le CRM",
      report_import: "Résultat du transfert %{time}",
      report_sync: "Résultat de la synchronisation %{time}",
      created: "créés",
      updated: "mis à jour",
      skipped: "ignorés",
      entities: {
        projects: "Projets",
        stages: "Étapes",
        companies: "Sociétés",
        contacts: "Contacts",
        leads: "Prospects",
        deals: "Affaires",
        notes: "Notes",
        tasks: "Tâches",
      },
      archived: "Supprimés dans Bitrix, archivés ici :",
      users_matched: "Employés de Bitrix trouvés ici par e-mail : %{count}",
      users_unmatched:
        "Introuvables ici par e-mail, leurs fiches vont au propriétaire :",
      lines: "À vérifier :",
      lines_all: "Tout afficher (%{count})",
      lines_less: "Réduire",
      badge: "de Bitrix",
      badge_hint: "Fiche Bitrix24. Elle se modifie dans Bitrix",
    },
    onec: {
      title: "1C",
      order: "Commande %{number} du %{date}",
      order_no_number: "Commande du %{date}",
      amount: "Montant",
      paid: "Payé",
      rest: "Reste",
      progress: "Payé %{percent} %",
      synced: "Synchronisé avec 1C %{time}",
      total: "Toutes les commandes :",
      total_line: "payé %{paid} sur %{amount}, reste %{rest}",
      empty:
        "Pas encore de commande dans 1C. Pour lier une commande, écrivez %{key} dans son commentaire",
      status: {
        unpaid: "Non payée",
        partial: "Payée en partie",
        paid: "Payée",
      },
    },
    mail: {
      title: "E-mails",
      write: "Écrire un e-mail",
      empty: "Aucun e-mail pour l'instant",
      only_latest:
        "Dernier %{smart_count} e-mail affiché |||| Derniers %{smart_count} e-mails affichés",
      to: "À",
      cc: "Cc",
      to_hint: "Séparez plusieurs adresses par des virgules",
      subject: "Objet",
      body: "Message",
      template: "Modèle",
      no_template: "Sans modèle",
      attach: "Joindre un fichier",
      attach_hint: "20 Mo au total au maximum",
      remove_file: "Retirer le fichier",
      send: "Envoyer",
      sent: "E-mail envoyé",
      sent_except: "E-mail envoyé, sauf : %{list}",
      status_sent_except: "envoyé, sauf : %{list}",
      send_error: "E-mail non envoyé",
      upload_error: "Le fichier n'a pas été envoyé",
      from: "De",
      no_subject: "(sans objet)",
      show_images: "Afficher les images",
      images_blocked: "Les images d'internet ne sont pas chargées",
      as_text: "En texte",
      as_html: "Comme envoyé",
      attachments: "Pièces jointes",
      files_not_kept:
        "Le CRM ne garde pas les fichiers des e-mails reçus. Ouvrez-les dans votre messagerie.",
      status: {
        queued: "envoi en cours",
        sent: "envoyé",
        failed: "non envoyé",
        received: "reçu",
      },
      direction: {
        in: "Reçu",
        out: "Envoyé",
      },
      mailbox: {
        title: "E-mail",
        hint: "Les e-mails des fiches partent de votre boîte, et le CRM y lit les réponses toutes les 5 minutes. Sans boîte personnelle, ils partent de la boîte de l'entreprise.",
        presets: "Remplir pour",
        from_addr: "Adresse e-mail",
        from_hint:
          "L'adresse de l'identifiant, ou une autre adresse du même domaine",
        from_name: "Nom de l'expéditeur",
        smtp_host: "Serveur SMTP",
        smtp_port: "Port SMTP",
        imap_host: "Serveur IMAP",
        imap_port: "Port IMAP",
        login: "Identifiant",
        login_hint:
          "En général l'adresse e-mail. Vide : le CRM prend l'adresse e-mail.",
        password: "Mot de passe d'application",
        password_hint:
          "Pour Yandex, Mail.ru et Gmail, créez un mot de passe d'application dans les réglages de sécurité de la boîte. Le mot de passe habituel ne marche pas.",
        is_set: "saisi",
        save: "Enregistrer l'e-mail",
        saved: "Réglages e-mail enregistrés",
        nothing_typed: "Remplissez au moins un champ",
        check: "Vérifier",
        check_label: "Vérifier l'e-mail",
        remove: "Supprimer la boîte",
        removed: "Boîte supprimée",
        status_ok: "L'envoi est configuré",
        status_none: "Aucune boîte",
        uses_company: "Les e-mails partent de la boîte de l'entreprise",
      },
    },
    mail_templates: {
      title: "Modèles d'e-mails",
      hint: "Vous pouvez écrire {{клиент}}, {{сделка}}, {{сумма}} et {{менеджер}} dans l'objet et le texte. Le CRM les remplit quand un employé choisit le modèle.",
      add: "Ajouter un modèle",
      new_name: "Nouveau modèle",
      name: "Nom",
      subject: "Objet",
      body: "Texte",
      save: "Enregistrer",
      saved: "Modèle enregistré",
      delete: "Supprimer",
      deleted: "Modèle supprimé",
      empty: "Aucun modèle pour l'instant",
    },
    calls: {
      title: "Appels",
      empty: "Aucun appel pour l'instant",
      call: "Appeler",
      calling: "Appel en cours… décrochez votre téléphone",
      call_error: "Impossible de passer l'appel",
      listen: "Écouter",
      nobody: "Employé inconnu",
      only_latest:
        "Dernier %{smart_count} appel affiché |||| %{smart_count} derniers appels affichés",
      kind: {
        incoming: "Entrant",
        outgoing: "Sortant",
        missed: "Manqué",
      },
      status: {
        in_progress: "en cours",
        success: "conversation",
        missed: "sans réponse",
        busy: "occupé",
        cancel: "annulé",
      },
      ext_label: "Poste",
      ext_hint:
        "Numéro de poste ou identifiant PBX. Le CRM l'utilise pour savoir qui a parlé et pour appeler depuis une fiche.",
      no_ext_hint:
        "Non renseigné, donc pas de bouton Appeler. Le propriétaire le renseigne dans Paramètres → Employés.",
      ext_saved: "Poste enregistré",
    },
    board: {
      stage_total: "Total pour %{stage}",
    },
    today: {
      title: "Aujourd'hui",
      counter_overdue: "En retard",
      counter_today: "Aujourd'hui",
      counter_stale: "Affaires inactives",
      my_tasks: "Mes tâches du jour",
      no_tasks: "Rien de prévu aujourd'hui",
      new_leads: "Nouveaux prospects",
      stale_deals: "Affaires sans mouvement depuis 7 jours",
      no_stale_deals: "Toutes les affaires ouvertes ont bougé cette semaine",
      idle_days:
        "%{smart_count} jour sans mouvement |||| %{smart_count} jours sans mouvement",
      more: "et %{smart_count} de plus",
    },
    common: {
      more_fields: "Plus",
      account_manager: "Responsable de compte",
      activity: "Activité",
      added: "ajoutée",
      details: "Détails",
      last_activity_with_date: "dernière activité %{date}",
      load_more: "Charger plus",
      misc: "Divers",
      past: "Passé",
      read_more: "En savoir plus",
      retry: "Réessayer",
      show_less: "Afficher moins",
      task_count: "%{smart_count} tâche |||| %{smart_count} tâches",
      copied: "Copié !",
      copy: "Copier",
      loading: "Chargement...",
      me: "Moi",
    },
    changelog: {
      title: "Notes de version",
    },
    activity: {
      added_company: "%{name} a ajouté l'entreprise",
      you_added_company: "Vous avez ajouté l'entreprise",
      added_contact: "%{name} a ajouté le contact",
      you_added_contact: "Vous avez ajouté le contact",
      added_note: "%{name} a ajouté une note sur",
      you_added_note: "Vous avez ajouté une note sur",
      added_note_about_deal: "%{name} a ajouté une note sur l'affaire",
      you_added_note_about_deal: "Vous avez ajouté une note sur l'affaire",
      added_deal: "%{name} a ajouté l'affaire",
      you_added_deal: "Vous avez ajouté l'affaire",
      at_company: "chez",
      to: "à",
      load_more: "Charger plus d'activité",
    },
    dashboard: {
      deals_chart: "Revenus des affaires à venir",
      deals_pipeline: "Pipeline des affaires",
      latest_activity: "Dernière activité",
      latest_activity_error:
        "Erreur lors du chargement de la dernière activité",
      latest_notes: "Mes dernières notes",
      latest_notes_added_ago: "ajouté %{timeAgo}",
      recent_contacts: "Consultés récemment",
      stepper: {
        install: "Installer Atomic CRM",
        progress: "%{step}/3 terminé",
        whats_next: "Et ensuite ?",
      },
      upcoming_tasks: "Tâches à venir",
    },
    data_import: {
      button: "Importer un fichier CSV",
      complete:
        "Import terminé. %{importCount} enregistrements importés, %{errorCount} erreurs",
      csv_file: "Fichier CSV",
      error:
        "Échec de l'importation de ce fichier. Veuillez vous assurer que vous avez fourni un fichier CSV valide.",
      in_progress: "Import en cours…",
      progress:
        "%{importCount} / %{rowCount} enregistrements importés, avec %{errorCount} erreurs.",
      remaining_time: "Temps restant estimé :",
      resource: "Ressource",
      sample_download: "Télécharger un exemple CSV",
      sample_hint:
        "Voici un exemple de fichier CSV que vous pouvez utiliser comme modèle",
      start: "Démarrer l'import",
      stop: "Arrêter l'importation",
      stopped:
        "Import arrêté. %{importCount} enregistrements importés, %{errorCount} erreurs",
      title: "Importer des données",
    },
    header: {
      import_data: "Importer depuis JSON",
    },
    search: {
      title: "Rechercher",
      placeholder:
        "Rechercher un contact, une entreprise, une affaire, une tâche, une note...",
      hint: "Saisissez au moins %{min} caractères pour lancer la recherche",
      empty: "Aucun résultat",
      error:
        "La recherche est indisponible pour le moment. Veuillez réessayer.",
      untitled_result: "(sans titre)",
      show_more: "Afficher plus",
      groups: {
        contacts: "Contacts",
        companies: "Entreprises",
        leads: "Leads",
        deals: "Affaires",
        tasks: "Tâches",
        contact_notes: "Notes de contact",
        deal_notes: "Notes d'affaire",
      },
    },
    image_editor: {
      change: "Changer",
      drop_hint:
        "Déposez un fichier à télécharger ou cliquez pour le sélectionner.",
      editable_content: "Contenu modifiable",
      title: "Télécharger et redimensionner l'image",
      update_image: "Mettre à jour l'image",
    },
    import: {
      action: {
        download_error_report: "Téléchargez le rapport d'erreur",
        import: "Importer",
        import_another: "Importer un autre fichier",
      },
      error: {
        unable: "Impossible d'importer ce fichier.",
      },
      idle: {
        description_1:
          "Vous pouvez importer des ventes, des entreprises, des contacts, des entreprises, des notes et des tâches.",
        description_2:
          "Les données doivent se trouver dans un fichier JSON correspondant à l'exemple suivant :",
      },
      status: {
        all_success: "Tous les enregistrements ont été importés avec succès.",
        complete: "Importation terminée.",
        failed: "Échoué",
        imported: "Importé",
        in_progress: "Import en cours, veuillez ne pas quitter cette page.",
        some_failed: "Certains enregistrements n'ont pas été importés.",
        table_caption: "Statut d'importation",
      },
      title: "Importer depuis JSON",
    },
    settings: {
      about: "À propos",
      companies: {
        sectors: "Secteurs",
      },
      dark_mode_logo: "Logo du mode sombre",
      deals: {
        categories: "Catégories",
        currency: "Devise",
        pipeline_help:
          "Sélectionnez les étapes d'affaire à considérer comme des affaires dans le pipeline.",
        pipeline_statuses: "Statuts des pipelines",
        stages: "Étapes",
      },
      light_mode_logo: "Logo du mode clair",
      notes: {
        statuses: "Statuts",
      },
      reset_defaults: "Réinitialiser aux valeurs par défaut",
      save_error: "Échec de l'enregistrement de la configuration",
      saved: "Configuration enregistrée avec succès",
      saving: "Enregistrement...",
      tasks: {
        types: "Types",
      },
      preferences: "Préférences",
      title: "Paramètres",
      app_title: "Titre de l'application",
      timezone: "Fuseau horaire",
      timezone_hint:
        "La journée de l'entreprise : quand une tâche est en retard et quand partent les notifications (de 9 h à 20 h).",
      sections: {
        branding: "Image de marque",
      },
      validation: {
        duplicate: "%{display_name} en double : %{items}",
        in_use:
          "Impossible de supprimer %{display_name} encore utilisés par des affaires : %{items}",
        validating: "Validation\u2026",
        entities: {
          categories: "catégories",
          stages: "étapes",
        },
      },
    },
    theme: {
      dark: "Sombre",
      label: "Thème",
      light: "Clair",
      system: "Système",
    },
    language: "Langue",
    navigation: {
      label: "Navigation CRM",
      leads: "Prospects",
      clients: "Clients",
      today: "Aujourd'hui",
    },
    profile: {
      add_secondary_email: "Ajouter un e-mail",
      email_taken: "%{email} est déjà utilisée par un autre utilisateur",
      no_secondary_emails: "Aucun",
      secondary_email_invalid: "%{email} n'est pas une adresse e-mail valide",
      secondary_email_is_primary: "%{email} est déjà votre adresse principale",
      secondary_email_taken:
        "%{email} est déjà utilisée par un autre utilisateur",
      too_many_secondary_emails:
        "Vous ne pouvez pas ajouter plus de 10 adresses e-mail secondaires",
      secondary_emails_help:
        "Autres adresses depuis lesquelles vous envoyez des e-mails. Laissez-en une vide pour la supprimer.",
      inbound: {
        description:
          "Vous pouvez commencer à envoyer des e-mails vers l'adresse de réception de votre serveur, par exemple en l'ajoutant au champ %{field}. Atomic CRM traitera les e-mails et ajoutera des notes aux contacts correspondants.",
        title: "E-mail entrant",
      },
      mcp: {
        title: "Serveur MCP",
        description:
          "Utilisez cette URL pour connecter votre assistant IA aux données de votre CRM via le Model Context Protocol (MCP).",
      },
      password: {
        change: "Changer le mot de passe",
        current: "Mot de passe actuel",
        new: "Nouveau mot de passe",
        changed: "Votre mot de passe a été modifié",
      },
      password_reset_sent:
        "Un e-mail de réinitialisation du mot de passe a été envoyé à votre adresse e-mail",
      record_not_found: "Enregistrement introuvable",
      title: "Profil",
      updated: "Votre profil a été mis à jour",
      update_error: "Une erreur s'est produite. Veuillez réessayer",
    },
    validation: {
      invalid_url: "Doit être une URL valide",
      invalid_linkedin_url: "L'URL doit provenir de linkedin.com",
    },
  },
} satisfies CrmMessages;
